export default "__VITE_ASSET__C6HsRj1z__"